"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AccountMan_1 = __importDefault(require("@kawaui/icons/build/icons/action/AccountMan"));
const Communication_1 = __importDefault(require("@kawaui/icons/build/icons/action/Communication"));
const HeartAction_1 = __importDefault(require("@kawaui/icons/build/icons/action/HeartAction"));
const Help_1 = __importDefault(require("@kawaui/icons/build/icons/action/Help"));
const MyAddress_1 = __importDefault(require("@kawaui/icons/build/icons/action/MyAddress"));
const MySubscriptions_1 = __importDefault(require("@kawaui/icons/build/icons/action/MySubscriptions"));
const Orders_1 = __importDefault(require("@kawaui/icons/build/icons/action/Orders"));
const PersonalInfo_1 = __importDefault(require("@kawaui/icons/build/icons/action/PersonalInfo"));
const Settings_1 = __importDefault(require("@kawaui/icons/build/icons/action/Settings"));
const Vouchers_1 = __importDefault(require("@kawaui/icons/build/icons/action/Vouchers"));
const Butterfly_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Butterfly"));
const ContactUs_1 = __importDefault(require("@kawaui/icons/build/icons/informative/ContactUs"));
const ReinsuranceCommitmentVp_1 = __importDefault(require("@kawaui/icons/build/icons/reinsurance/ReinsuranceCommitmentVp"));
const ReinsurancePayment_1 = __importDefault(require("@kawaui/icons/build/icons/reinsurance/ReinsurancePayment"));
const SponsorshipCh_1 = __importDefault(require("@kawaui/icons/build/icons/sponsorship/SponsorshipCh"));
const useHomepage_1 = __importDefault(require("../../../hooks/useHomepage"));
const useTracking_1 = __importDefault(require("../../../hooks/useTracking"));
const utils_1 = require("../../../utils");
const link_1 = __importDefault(require("../../link"));
const LateralMenuStyled = __importStar(require("../styles"));
const iconsMap = {
    Profile: AccountMan_1.default,
    Paper: PersonalInfo_1.default,
    Book: MyAddress_1.default,
    Orders: Orders_1.default,
    Gift: Vouchers_1.default,
    Bell: Communication_1.default,
    Heart: HeartAction_1.default,
    Wheel: Settings_1.default,
    Persons: SponsorshipCh_1.default,
    Card: ReinsurancePayment_1.default,
    Help: Help_1.default,
    Hands: ReinsuranceCommitmentVp_1.default,
    Subscriptions: MySubscriptions_1.default,
    VeepeeButterfly: Butterfly_1.default,
    Discussions: ContactUs_1.default,
};
const MenuItem = ({ item, isOpenDoor }) => {
    var _a, _b, _c, _d;
    const { generateLateralMenuHitConfig } = (0, useTracking_1.default)();
    const { highlighted } = (0, useHomepage_1.default)();
    const Icon = iconsMap[item.icon] || null;
    if (!(0, utils_1.shouldRenderByAuth)(item.authenticationState, isOpenDoor))
        return null;
    return ((0, jsx_runtime_1.jsx)(LateralMenuStyled.ListItem, { children: (0, jsx_runtime_1.jsxs)(link_1.default, { href: ((_a = item.target) === null || _a === void 0 ? void 0 : _a.internalLink) || ((_b = item.target) === null || _b === void 0 ? void 0 : _b.externalLink), variant: "tertiary", forcedExternal: !!((_c = item.target) === null || _c === void 0 ? void 0 : _c.externalLink), hitConfig: generateLateralMenuHitConfig((highlighted === null || highlighted === void 0 ? void 0 : highlighted.displayName) || '', item.id), children: [Icon && (0, jsx_runtime_1.jsx)(Icon, { width: 24, height: 24 }), (0, jsx_runtime_1.jsx)("span", { children: (_d = item.title) === null || _d === void 0 ? void 0 : _d.text })] }) }, item.id));
};
exports.default = MenuItem;
